import React from 'react';

const Card = ({
  children,
  title,
  subtitle,
  icon,
  actions,
  className = '',
  bodyClassName = '',
  noPadding = false
}) => {
  return (
    <div className={`bg-white rounded-lg shadow-sm overflow-hidden ${className}`}>
      {(title || subtitle || icon || actions) && (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-200">
          <div className="flex items-center space-x-3 mb-2 sm:mb-0">
            {icon && <div className="text-primary-600 flex-shrink-0">{icon}</div>}
            <div>
              {title && <h2 className="text-lg font-semibold text-gray-800">{title}</h2>}
              {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="mt-2 sm:mt-0">{actions}</div>}
        </div>
      )}
      <div className={`${noPadding ? '' : 'p-4 sm:p-6'} ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default Card;
